export const KPI_Card_Header_Label = {
  sku: 'SKU',
  model: 'Models',
  l1: 'L1',
  l2: 'L2',
  l3: 'L3',
}

export const SKU_Management_Filter_Label = {
  l1: 'L1',
  l2: 'L2',
  l3: 'L3',
  vendor: 'Vendor',
  modelCreator: 'Model Creator',
}

export const Selected_Filters_Initial_State = {
  l1: '',
  l2: '',
  l3: '',
  vendor: '',
  modelCreator: '',
}

export const SKU_Recommendation_Filter_Label = {
  l1: 'L1',
  l2: 'L2',
  l3: 'L3',
}

export const Default_Country = {
  COUNTRY: 'USA',
}

export const Currency_Data = [
  {
    label: '%',
    value: 'Percentage',
  },
  {
    label: '% Delta',
    value: 'Percentage Delta',
  },
  {
    label: 'USD : $',
    value: 'USD',
  },
  {
    label: 'EUR : €',
    value: 'EUR',
  },
  {
    label: 'GBP : £',
    value: 'GBP',
  },
  {
    label: 'CAD : C$',
    value: 'CAD',
  },
  // {
  //   label: 'INR : ₹',
  //   value: 'INR',
  // },
]

export const Creation_Source = {
  SKU_Management: 'sku_management',
  Should_Cost_Uploader: 'should_cost_uploader',
  Should_Cost_Builder: 'should_cost_builder',
}

export const Creation_Approach = {
  top_down: 'Top Down',
  bottom_up: 'Bottom Up',
}
